import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Card,
  CardContent,
  Typography,
  Box,
  InputAdornment,
  Divider,
  Avatar,
} from "@mui/material";
import {
  Lock,
  Person,
  VpnKey,
  QrCode2,
  CheckCircle,
} from "@mui/icons-material";
import { API_BASE_URL } from "../constant/constant";

const TwoFactorAuth = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [qr, setQr] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [is2FASetup, setIs2FASetup] = useState(false);
  const [message, setMessage] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("info");

  const navigate = useNavigate();

  /* ================= LOGIC (UNCHANGED) ================= */

  const handleLogin = async () => {
    try {
      const res = await axios.post(`${API_BASE_URL}/api/2falogin`, {
        userId: username,
        password,
      });

      if (res.data.secret) {
        setIsAuthenticated(true);
        setIs2FASetup(true);
      } else {
        const setupRes = await axios.get(
          `${API_BASE_URL}/2fa/setup/${username}`
        );
        setQr(setupRes.data.qr);
        setIsAuthenticated(true);
        setIs2FASetup(false);
      }
    } catch (err) {
      showMessage(
        err.response?.data?.message || "Login failed",
        "error"
      );
    }
  };

 const handleOtpChange = (value, index) => {
  if (!/^\d?$/.test(value)) return;

  const otpArr = otp.split("");
  otpArr[index] = value;
  const newOtp = otpArr.join("");

  setOtp(newOtp);

  if (value && index < 5) {
    document.getElementById(`otp-${index + 1}`)?.focus();
  }

  if (newOtp.length === 6 && !newOtp.includes("")) {
    verifyOTP(newOtp);
  }
};

const handleOtpKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    e.preventDefault();

    const otpArr = otp.split("");

    if (otpArr[index]) {
      otpArr[index] = "";
      setOtp(otpArr.join(""));
    } else if (index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
      otpArr[index - 1] = "";
      setOtp(otpArr.join(""));
    }
  }

  if (e.key === "ArrowLeft" && index > 0) {
    document.getElementById(`otp-${index - 1}`)?.focus();
  }

  if (e.key === "ArrowRight" && index < 5) {
    document.getElementById(`otp-${index + 1}`)?.focus();
  }
};

const handleOtpPaste = (e) => {
  e.preventDefault();
  const pasteData = e.clipboardData
    .getData("text")
    .replace(/\D/g, "")
    .slice(0, 6);

  if (!pasteData) return;

  setOtp(pasteData.padEnd(6, ""));

  if (pasteData.length === 6) {
    verifyOTP(pasteData);
  }

  setTimeout(() => {
    document
      .getElementById(`otp-${pasteData.length - 1}`)
      ?.focus();
  }, 0);
};


  const verifyOTP = async (otpValue = otp) => {
    try {
      const res = await axios.post(`${API_BASE_URL}/2fa/verify`, {
        username,
        token: otpValue,
      });

      showMessage(res.data.message, "success");

      localStorage.setItem("token", res.data.jwttoken);
      sessionStorage.setItem("token", res.data.jwttoken);
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("tokenData", res.data.encrypted);
      localStorage.setItem("expiryTime", res.data.expiryTime);

      navigate("/dashboard");
    } catch (err) {
      showMessage(
        err.response?.data?.message || "OTP verification failed",
        "error"
      );
    }
  };

  const showMessage = (msg, severity) => {
    setMessage(msg);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  useEffect(() => {
    const alreadyAuthenticated =
      localStorage.getItem("isAuthenticated") === "true";
    if (!alreadyAuthenticated) {
      navigate("/", { replace: true });
      localStorage.clear();
      sessionStorage.clear();
    }
  }, [navigate]);

  /* ================= UI ================= */

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #1e3c72, #2a5298)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Card
        sx={{
          width: 420,
          borderRadius: 4,
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          backdropFilter: "blur(10px)",
        }}
      >
        <CardContent sx={{ p: 4 }}>
          {/* HEADER */}
          {/* HEADER */}
<Box textAlign="center" mb={3}>
  <Avatar
    sx={{
      bgcolor: "primary.main",
      width: 60,
      height: 60,
      mx: "auto",
      mb: 1,
    }}
  >
    <Lock />
  </Avatar>

  <Typography variant="h5" fontWeight={700}>
    Unified Secure Login
  </Typography>
{/* //• School • Hospital Systems */}
  <Typography
    fontSize={13}
    color="text.secondary"
    sx={{ mt: 0.5 }}
  >
    Access Gateway for RIB 
  </Typography>

  <Typography
    fontSize={12}
    sx={{ mt: 1, color: "success.main", fontWeight: 600 }}
  >
    🔐 Protected by Two-Factor Authentication
  </Typography>
</Box>

<Divider sx={{ mb: 3 }} />

{/* SYSTEM BADGES */}
<Box
  display="flex"
  justifyContent="center"
  gap={1.5}
  mb={3}
  flexWrap="wrap"
>
  <Box
    sx={{
      px: 1.5,
      py: 0.5,
      borderRadius: 2,
      bgcolor: "#e3f2fd",
      fontSize: 12,
      fontWeight: 600,
    }}
  >
    💰 Remittance into Bank (RIB) Data Management System
  </Box>

  {/* <Box
    sx={{
      px: 1.5,
      py: 0.5,
      borderRadius: 2,
      bgcolor: "#e8f5e9",
      fontSize: 12,
      fontWeight: 600,
    }}
  >
    🏫 School Management
  </Box>

  <Box
    sx={{
      px: 1.5,
      py: 0.5,
      borderRadius: 2,
      bgcolor: "#fce4ec",
      fontSize: 12,
      fontWeight: 600,
    }}
  >
    🏥 Hospital Management
  </Box>*/}
</Box> 


          <Divider sx={{ mb: 3 }} />

          {/* LOGIN FORM */}
          {!isAuthenticated ? (
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                size="small"
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                size="small"
                label="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <VpnKey />
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                variant="contained"
                size="large"
                onClick={handleLogin}
                sx={{
                  mt: 2,
                  py: 1.2,
                  borderRadius: 2,
                  fontWeight: 600,
                }}
              >
                Login
              </Button>
            </Box>
          ) : (
            /* OTP SECTION */
            <Box display="flex" flexDirection="column" gap={2}>
              {!is2FASetup && (
                <>
                  <Typography
                    textAlign="center"
                    fontWeight={600}
                  >
                    Scan QR with Google Authenticator
                  </Typography>

                  <Box textAlign="center">
                    <img
                      src={qr}
                      alt="QR Code"
                      style={{ height: 180 }}
                    />
                  </Box>
                </>
              )}

            {/* OTP SECTION */}
<Box mt={2} textAlign="center">
  <Typography fontWeight={600} mb={1}>
    Enter 6-Digit OTP from Google Authenticator
  </Typography>

  <Typography fontSize={12} color="text.secondary" mb={2}>
    Time-based One-Time Password (TOTP)
  </Typography>

  <Box
    display="flex"
    justifyContent="center"
    gap={1.2}
    onPaste={handleOtpPaste}
  >
    {Array.from({ length: 6 }).map((_, index) => (
      <TextField
        key={index}
        id={`otp-${index}`}
        value={otp[index] || ""}
        onChange={(e) =>
          handleOtpChange(e.target.value, index)
        }
        onKeyDown={(e) =>
          handleOtpKeyDown(e, index)
        }
        inputProps={{
          maxLength: 1,
          inputMode: "numeric",
          style: {
            textAlign: "center",
            fontSize: "26px",
            fontWeight: 700,
          },
        }}
        sx={{
          width: 50,
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
          },
        }}
      />
    ))}
  </Box>

  <Button
    variant="contained"
    color="success"
    size="large"
    onClick={() => verifyOTP()}
    sx={{
      mt: 3,
      px: 6,
      py: 1.2,
      borderRadius: 2,
      fontWeight: 600,
    }}
  >
    Verify OTP
  </Button>
</Box>


            </Box>
          )}

          {/* FOOTER */}
         <Typography
  textAlign="center"
  fontSize={12}
  color="text.secondary"
  mt={4}
>
  © {new Date().getFullYear()} <b>Sriyansh Computers</b>
  <br />
  <Box
    component="a"
    href="https://www.sriyansh.com"
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      color: "primary.main",
      textDecoration: "none",
      fontWeight: 600,
    }}
  >
    www.sriyansh.com
  </Box>
</Typography>

        </CardContent>
      </Card>

      {/* SNACKBAR */}
      <Snackbar
        open={snackOpen}
        autoHideDuration={4000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackSeverity}
          variant="filled"
          onClose={() => setSnackOpen(false)}
          sx={{ borderRadius: 2 }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TwoFactorAuth;
